import { isProduction } from '../../data/constants.ts';
import '../overlays/as-tooltip.ts';

/**
 * <as-param-warning>
 * 
 * Standardized warning indicator for missing Paramate parameters.
 * Only renders its content if is-missing is true and not in production.
 */
export class AsParamWarning extends HTMLElement {
  static get observedAttributes() {
    return ['trcad-param', 'is-missing'];
  }

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    this.render();
  }

  attributeChangedCallback() {
    this.render();
  }

  render() {
    const isMissing = this.hasAttribute('is-missing') && this.getAttribute('is-missing') !== 'false';
    const paramName = this.getAttribute('trcad-param') ?? 'unknown';

    if (!isMissing || isProduction) {
      this.shadowRoot!.innerHTML = '';
      return;
    }

    this.shadowRoot!.innerHTML = `
      <style>
        :host {
          display: inline-block;
          vertical-align: middle;
          margin-left: 4px;
        }
        .warning-icon {
          color: #d9534f;
          font-weight: bold;
          cursor: help;
          border: 1px solid #d9534f;
          border-radius: 50%;
          width: 14px;
          height: 14px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 10px;
        }
      </style>
      <as-tooltip-wrapper placement="top" show-on-hover default-text="Parameter '${paramName}' not found in configurator">
        <span class="warning-icon">!</span>
      </as-tooltip-wrapper>
    `;
  }
}

if (!customElements.get('as-param-warning')) {
  customElements.define('as-param-warning', AsParamWarning);
}
